import React, { useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const HotelActionsMenu = ({ hotel, hasLuniShower, hasGreenMiles, isOpen, onClose, showUp = false, onUpdateStatus, onGenerateSnapshot, onEditDescription, onEditHotel }) => {
  const navigate = useNavigate();
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, onClose]);

  const handleViewLogs = (e) => {
    e.stopPropagation();
    navigate(`/hotels/${hotel.id}?tab=lunishower`, { state: { from: "/hotels" } });
    onClose();
  };

  const handleUpdateStatus = async (e) => {
    e.stopPropagation();
    try {
      await onUpdateStatus(hotel.manager_id, hotel.id);
    } catch (error) {
      console.error("Erreur lors de la mise à jour:", error);
    }
    onClose();
  };

  const handleGenerateSnapshot = async (e) => {
    if (!onGenerateSnapshot) return;
    e.stopPropagation();
    try {
      await onGenerateSnapshot(hotel.manager_id, hotel.id);
    } catch (error) {
      console.error("Erreur lors de la génération du snapshot:", error);
    }
    onClose();
  };

  const handleEditDescription = (e) => {
    e.stopPropagation();
    onEditDescription(hotel);
    onClose();
  };

  const handleEditHotel = (e) => {
    e.stopPropagation();
    onEditHotel?.(hotel);
    onClose();
  };

  const handleOpenGreenMiles = (e) => {
    e.stopPropagation();
    navigate(`/hotels/${hotel.id}/greenmiles`, { state: { from: "/hotels" } });
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div ref={menuRef} className={`absolute right-0 w-56 bg-white border border-gray-200 rounded-md shadow-lg z-10 ${showUp ? "bottom-full mb-2" : "mt-2"}`}>
      <div className="py-2">
        {onEditHotel && (
          <button onClick={handleEditHotel} className="w-full px-4 py-3 text-left hover:bg-blue-50 cursor-pointer text-blue-600 font-medium transition-colors duration-150">
            Modifier l&apos;hôtel
          </button>
        )}
        {hasLuniShower && (
          <>
            <button onClick={handleViewLogs} className="w-full px-4 py-3 text-left hover:bg-gray-100 cursor-pointer text-gray-700 font-medium transition-colors duration-150">
              Voir les logs
            </button>
            <button onClick={handleUpdateStatus} className="w-full px-4 py-3 text-left hover:bg-gray-100 cursor-pointer text-gray-700 font-medium transition-colors duration-150">
              Mettre à jour les statuts
            </button>
            {onGenerateSnapshot && (
              <button onClick={handleGenerateSnapshot} className="w-full px-4 py-3 text-left hover:bg-gray-100 cursor-pointer text-gray-700 font-medium transition-colors duration-150">
                Générer un snapshot
              </button>
            )}
            <button onClick={handleEditDescription} className="w-full px-4 py-3 text-left hover:bg-blue-50 cursor-pointer text-blue-600 font-medium transition-colors duration-150">
              Modifier la description
            </button>
          </>
        )}
        {hasGreenMiles && (
          <button onClick={handleOpenGreenMiles} className="w-full px-4 py-3 text-left hover:bg-emerald-50 cursor-pointer text-emerald-700 font-medium transition-colors duration-150">
            Ouvrir en GreenMiles
          </button>
        )}
      </div>
    </div>
  );
};

export default HotelActionsMenu;
